{
  "aiGeneratedAnswer": "AI generirani odgovor",
  "allCategories": "Sve kategorije",
  "appliedFiltersToCurrentSearch": "Primijenjeni filtri na trenutnu pretragu",
  "apply": "Primijeni",
  "applyFilters": "Primijeni filtere",
  "autocompleteOptionsFound_few": "Pronađene su {{count}}{{label}} opcije za automatsko dovršavanje.",
  "autocompleteOptionsFound_one": "Pronađena je {{count}}{{label}} opcija za automatsko dovršavanje.",
  "autocompleteOptionsFound_other": "Pronađeno je {{count}}{{label}} opcija za automatsko dovršavanje.",
  "autocompleteSuggestion": "prijedlog za automatsko dovršavanje: {{suggestion}}",
  "autocompleteSuggestionsFound_few": "Pronađena su {{count}} prijedloga za automatsko dovršavanje.",
  "autocompleteSuggestionsFound_one": "Pronađen je {{count}} prijedlog za automatsko dovršavanje.",
  "autocompleteSuggestionsFound_other": "Pronađeno je {{count}} prijedloga za automatsko dovršavanje.",
  "basedOnYourDevice": " (na temelju vašeg uređaja)",
  "basedOnYourInternetAddress": " (na temelju vaše internet adrese)",
  "categoriesText_few": "Sljedeće kategorije dale su rezultate za - <strong>{{query}}</strong>",
  "categoriesText_one": "Sljedeća kategorija dala je rezultate za - <strong>{{query}}</strong>",
  "categoriesText_other": "Sljedeće kategorije dale su rezultate za - <strong>{{query}}</strong>",
  "clearAll": "Očisti sve",
  "clearMinAndMax": "Očisti min i max",
  "clearTheRangeToSelectOptions": "Očistite raspon za odabir opcija.",
  "clearTheSearchBar": "Očistite traku za pretraživanje",
  "conductASearch": "Provesti pretragu",
  "currentLocation": "Trenutna lokacija",
  "didYouMean": "Jeste li mislili na <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Kad su dostupni rezultati automatskog dovršavanja, koristite strelice gore i dolje za pregled i Enter za odabir.",
  "feedback": "Povratne informacije",
  "invalidRange": "Nevažeći raspon",
  "max": "Maks",
  "min": "Min",
  "navigateToTheNextResultsPage": "Dođite do sljedeće stranice rezultata",
  "navigateToThePreviousResultsPage": "Dođite do stranice s prethodnim rezultatima",
  "noAutocompleteOptionsFound": "Nije pronađena 0 opcija automatskog dovršavanja.",
  "noAutocompleteSuggestionsFound": "Nije pronađen 0 prijedloga za automatsko dovršavanje.",
  "noResultsFoundIn": "Nema rezultata u {{currentVerticalLabel}}.",
  "pagination": "Paginacija",
  "readMoreAbout": "Pročitaj više o <a>{{name}}</a>",
  "recentSearch": "nedavno pretraživanje: {{query}}",
  "recentSearchesFound_few": "Pronađene su {{count}} nedavne pretrage.",
  "recentSearchesFound_one": "Pronađena je {{count}} nedavna pretraga.",
  "recentSearchesFound_other": "Pronađeno je {{count}} nedavnih pretraga.",
  "removeFilter": "Ukloni filtar „{{displayName}}“",
  "resultPreview": "pregled rezultata: {{value}}",
  "resultPreviewsFound_few": "Pronađena su {{count}} pregleda rezultata.",
  "resultPreviewsFound_one": "Pronađen je {{count}} pregled rezultata.",
  "resultPreviewsFound_other": "Pronađeno je {{count}} pregleda rezultata.",
  "resultsCountText_few": "{{count}} rezultata",
  "resultsCountText_one": "{{count}} rezultat",
  "resultsCountText_other": "{{count}} rezultata",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} od {{resultsCount}} rezultata",
  "searchHere": "Pretražite ovdje…",
  "showLess": "Prikaži manje",
  "showMore": "Prikaži više",
  "showingAllInstead": "Prikazuju se svi {{currentVerticalLabel}} umjesto toga.",
  "sources_few": "Izvora ({{count}})",
  "sources_one": "Izvor",
  "sources_other": "Izvori ({{count}})",
  "submitSearch": "Pošaljite pretragu",
  "suggestionResultsCount_few": "{{label}} - {{count}} rezultata",
  "suggestionResultsCount_one": "{{label}} - {{count}} rezultat",
  "suggestionResultsCount_other": "{{label}} - {{count}} rezultata",
  "thankYouForYourFeedback": "Hvala na vašoj povratnoj informaciji!",
  "thisAnsweredMyQuestion": "Ovo je odgovorilo na moje pitanje",
  "thisDidNotAnswerMyQuestion": "Ovo nije odgovorilo na moje pitanje",
  "unselectAnOptionToEnterInARange": "Poništite odabir opcije da biste unijeli raspon.",
  "updateYourLocation": "Ažurirajte svoje mjesto",
  "useCurrentLocation": "Koristi trenutnu lokaciju",
  "useMyLocation": "Koristi moju lokaciju",
  "viewAll": "Pogledajte sve",
  "viewDetails": "Pogledajte detalje"
}
